import { MIME_LABEL, CHIP_COLORS } from './constants';
import { getExtension } from './helpers';
import styles from '../../styles/assetsManagement/filesManager.module.scss';

const FileTypeChip = ({ mimeType, fileName }) => {
  const label = MIME_LABEL[mimeType] || getExtension(fileName) || '?';
  const { bg, color } = CHIP_COLORS[label] || { bg: '#f1f5f9', color: '#475569' };
  return (
    <span className={styles.fileTypeChip} style={{ backgroundColor: bg, color }}>
      {label}
    </span>
  );
};

export default FileTypeChip;
